import { render, staticRenderFns } from "./GroupStats.vue?vue&type=template&id=3ab7eed2&scoped=true&"
import script from "./GroupStats.vue?vue&type=script&lang=js&"
export * from "./GroupStats.vue?vue&type=script&lang=js&"
import style0 from "./GroupStats.vue?vue&type=style&index=0&id=3ab7eed2&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab7eed2",
  null
  
)

export default component.exports